export type FieldMappingServer = {
  first_name: string;
  last_name: string;
};
export type SSOServer = {
  signOnUrl: string;
  issuer: string;
  provider: string;
  label: string;
  fieldMapping: FieldMappingServer;
  certificate: string;
  signOutUrl?: string;
};

export enum OrganizationEdition {
  standard = "standard",
  enterprise = "enterprise",
  dedicated = "dedicated",
}

type OrganizationCommonType = {
  organizationId: string;
  organizationName: string;
  organizationOwner: string;
  isPaymentRegistered: boolean;
  billingProfileName: string;
  networkPolicyName: string;
  created: string;
  lastAltered: string;
  lastAlteredBy: string;
  edition: OrganizationEdition;
  paymentMethodName: string;
  nextPaymentMethodName: string;
  creditsRemaining: string;
};

export type Organization = OrganizationCommonType & {
  sso: SSOServer;
};

export type OrganizationRaw = OrganizationCommonType & {
  sso: string;
};
